import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";
import { useCodeSearch } from "src/hooks/useCodeSearch";
import { createModuleConfig } from "src/utils/detail-table/detailTableUtils";
import { calculateDetailAmount } from "src/utils/calculation/calculationUtils";
import { SAL6010_R01DetailDto } from "../Dto_SAL6010_R01";

interface UseSAL6010_R01CellChangeProps {
	SAL6010_R01DetailList: SAL6010_R01DetailDto[];
	originalSAL6010_R01DetailList: SAL6010_R01DetailDto[];
	updateSAL6010_R01DetailList: (index: number, data: SAL6010_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<SAL6010_R01DetailDto> | null>;
	setCodeSearchModalProps: any;
}

export function useSAL6010_R01CellChange({
	SAL6010_R01DetailList,
	originalSAL6010_R01DetailList,
	updateSAL6010_R01DetailList,
	gridRef,
	setCodeSearchModalProps,
}: UseSAL6010_R01CellChangeProps) {
	const { searchExactCode } = useCodeSearch({});
	const SAL6010R01Config = createModuleConfig.SAL6010();

	const fieldConfigWithSearch = {
		...SAL6010R01Config.fieldConfig,
		codeSearchFields: {
			...SAL6010R01Config.fieldConfig.codeSearchFields,
			itemCd: {
				...SAL6010R01Config.fieldConfig.codeSearchFields!.itemCd,
				searchFunction: (code: string, onSuccess?: (item: any) => void) =>
					searchExactCode("item", code, onSuccess),
			},
		},
	};

	const SAL6010_FIELD_MAPPING = {
		qtyField: "estimateQty",
		priceField: "estimatePrice",
		dcField: "dcAmt",
		amountField: "itemAmt",
		preventNegative: true,
	};

	return useCommonDetailTableHandlers<SAL6010_R01DetailDto>({
		detailList: SAL6010_R01DetailList,
		updateDetailList: updateSAL6010_R01DetailList,
		originalDetailList: originalSAL6010_R01DetailList,
		setCodeSearchModalProps,
		gridRef,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig: SAL6010R01Config.codeSearchConfig,
		calculateAmount: (data: SAL6010_R01DetailDto) =>
			calculateDetailAmount(data, SAL6010_FIELD_MAPPING),
	});
}
